export interface Notification {
    type: NotificationType;
    message: string;
  saveMsg: boolean;
  timeOut: number;
}
export enum NotificationType {
    Success,
    Error,
    Info,
    Warning
}
